import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

interface ShowCardsSVGProps {
  iconFill?: string
}

export const ShowCardsSVG = ({
  iconFill = Palette['Global/Black'],
  ...rest
}: React.ComponentProps<typeof Svg> & ShowCardsSVGProps) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...rest}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C4 2.89543 4.89543 2 6 2H12C13.1046 2 14 2.89543 14 4V15C14 16.1046 13.1046 17 12 17H6C4.89543 17 4 16.1046 4 15V4ZM6 3.5H12C12.2761 3.5 12.5 3.72386 12.5 4V15C12.5 15.2761 12.2761 15.5 12 15.5H6C5.72386 15.5 5.5 15.2761 5.5 15V4C5.5 3.72386 5.72386 3.5 6 3.5Z"
      fill={iconFill}
    />
    <Path
      d="M11.5 20V18.5H10V20C10 21.1046 10.8954 22 12 22H18C19.1046 22 20 21.1046 20 20V9C20 7.89543 19.1046 7 18 7H15.5V8.5H18C18.2761 8.5 18.5 8.72386 18.5 9V20C18.5 20.2761 18.2761 20.5 18 20.5H12C11.7239 20.5 11.5 20.2761 11.5 20Z"
      fill={iconFill}
    />
  </Svg>
)
